module.exports = __webpack_public_path__ + "style/img/PD_icon_BossMa2 1.6b7191ea.png";